module.exports = __webpack_public_path__ + "static/media/logo-cosh.a07f1ecb.png";